export const SORT_ORDERS = {
  ASC: "Ascending",
  DESC: "Descending",
};

export const ROUTE_SORT_TYPES = {
  ROUTE_NUMBER: "Route Number",
  DUTY_START_TIME: "Duty Start Time",
  DUTY_END_TIME: "Duty End Time",
  FORECAST_READY_TIME: "Forecast Ready Time",
  STOPS: "Stops",
  PARCELS: "Parcels",
  WEIGHT: "Weight",
  DUTY_TIME_EXCEPTIONS: "Duty Time Exceptions",
  OPPORTUNITY_TIME: "Opportunity Time",
};

export const ROUTE_SORT_TYPES_AVAILABILITY = {
  [ROUTE_SORT_TYPES.ROUTE_NUMBER]: {},
  [ROUTE_SORT_TYPES.DUTY_START_TIME]: {},
  [ROUTE_SORT_TYPES.DUTY_END_TIME]: {},
  [ROUTE_SORT_TYPES.FORECAST_READY_TIME]: {},
  [ROUTE_SORT_TYPES.STOPS]: { withVolumeDataOnly: true },
  [ROUTE_SORT_TYPES.PARCELS]: { withVolumeDataOnly: true },
  [ROUTE_SORT_TYPES.WEIGHT]: { withVolumeDataOnly: true },
  [ROUTE_SORT_TYPES.DUTY_TIME_EXCEPTIONS]: {
    withVolumeDataOnly: true,
    withOptimisationOnly: true,
  },
  [ROUTE_SORT_TYPES.OPPORTUNITY_TIME]: {
    withVolumeDataOnly: true,
    withOptimisationOnly: true,
  },
};

export const DRIVER_SORT_TYPES = {
  DRIVER_NUMBER: "Driver Number",
  DRIVER_NAME: "Driver Name",
};

export const SECTION_SORT_TYPES = {
  SECTION_NAME: "Section Name",
};

export const SHIFT_MANAGERS_SORT_TYPES = {
  SHIFT_MANAGER_CODE: "Shift Manager Code",
  SHIFT_MANAGER_NAME: "Shift Manager Name",
};
